import { INavItem } from '../interfaces/navItem';

declare let nav_items: INavItem[];
declare let sideBarNavIcon: boolean;

export let treePosition: Array<number> | null = null;
export const getCurrentPosition = (navChildren = nav_items, position: number[] = []): number[] => {
  if (typeof navChildren !== 'undefined') {
    for (const [i, navChild] of navChildren.entries()) {
      if (navChild.childSelected && navChild.browsable) {
        // 1st+ level
        position.push(i);
        return getCurrentPosition(navChild.browsableChildren, position);
      } else if (!navChild.childSelected && navChild.selected) {
        // last level
        position.push(i);
        return position;
      }
    }
  }
};

export function initTreePosition() {
  if (typeof nav_items !== 'undefined') {
    treePosition = treePosition || getCurrentPosition() || [];
  } else {
    treePosition = treePosition || [];
  }
}

export const getLevels = (pos = treePosition || [], result: INavItem[] = []): INavItem[] => {
  if (!pos.length) {
    return result.slice().reverse();
  }

  return getLevels(
    pos.slice(0, pos.length - 1),
    result.concat(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      pos.reduce((acc: any, curr: any, index: number) => (index ? acc.browsableChildren[curr] : acc[curr]), nav_items),
    ),
  );
};

export const initSidebar = (): void => {
  if (typeof sideBarNavIcon !== 'undefined' && sideBarNavIcon) {
    // eslint-disable-next-line no-restricted-globals
    const urlNoSlashes = location.pathname.replace(/\//gi, '');
    $('.' + urlNoSlashes).addClass('active');
    if ($('li.' + urlNoSlashes + ':first-child').hasClass('active')) {
      $('.link-text').addClass('show');
    }
    return;
  } else {
    initTreePosition();
    const computedLevels = getLevels();
    let highlightedLevel = null;
    // Determines which level has to be highlighted and if it's a level without subsites
    if (computedLevels.length > 1 && !computedLevels[computedLevels.length - 1].browsableChildren.length) {
      highlightedLevel = computedLevels.pop();
    }
    for (let i = 0; i < computedLevels.length; i++) {
      const level = computedLevels[i];

      if (i === computedLevels.length - 1) {
        $('#nav-links').append(`<li><a href="${level.URL}">${level.name}</a></li>`);
        const bcEntries = level.browsableChildren;
        for (let i = 0; i < bcEntries.length; i++) {
          const item = bcEntries[i];
          $('#nav-links').append(
            `<li><a href="${item.URL}"${
              highlightedLevel && item.URL === highlightedLevel.URL ? ' class="active"' : ''
            }>${item.name}</a></li>`,
          );
        }
        break;
      }
      $('#nav-breadcrumbs').append(`<li><a href="${level.URL}">${level.name}</a></li>`);
    }

    if (!$('#nav-links li').length) $('#sidebar-links').removeClass('d-none');
  }
};
